(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bazaar-weekly-price')) {
    customElements.define('bazaar-weekly-price', class extends HTMLElement {
      connectedCallback() {
        const remaining = Date.parse(this.dataset.end) - Date.now();
        if (remaining <= 0) this.expire();
        else this.timer = setTimeout(() => this.expire(), Math.min(remaining, 2147483647));
      }
      expire() {
        this.hidden = true;
        this.closest('[ref="priceContainer"]')?.removeAttribute('data-weekly-offer');
      }
      disconnectedCallback() { clearTimeout(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
